export default {
  mfaPage: {
    banner: {
      title: "自适应多因素认证",
      subtitle:
        "自适应多因素认证 MFA 是一种简单有效的安全实践方法，它能够在用户名和密码之外再额外增加一层安全保护，在不牺牲用户体验的情况下进行安全身份验证。",
      bannerImg: "//files.authing.co/authing-website/mfa-banner-img.png",
    },
    advantageData: {
      0: { label: "降低安全风险", value: "75%" },
      1: { label: "提升用户效率", value: "50%" },
      2: { label: "减少数据泄露风险", value: "90%" },
    },
    features: {
      blockOne: {
        title: "更多安全，更优体验，更高性能",
        descript1:
          "「自适应」多因素认证较于传统多因素认证 MFA，能够根据当前安全状况，选择应用不同的 MFA 方式，在保障安全的同时兼顾用户体验。自适应多因素认证 MFA 提供了更加灵活和智能的验证策略。",
        descript2:
          " 在用户进行认证流程时，自适应多因素认证对当前登录的用户生成的多种「关键要素」",
        item1: {
          title: "用户属性",
          descript: "例如用户名、密码、用户身份等用户自身的属性和信息",
        },
        item2: {
          title: "位置感知",
          descript: "位置感知分为虚拟位置（IP 地址）和物理位置（国家、地区等）",
        },
        item3: {
          title: "行为分析",
          descript:
            "是否来自常用的登录地点、是否多次输入错误密码、用户之前的操作记录等一系列用户行为",
        },
        item4: {
          title: "请求来源",
          descript:
            "对当前用户的请求来源进行判断，如：硬件设备信息、用户当前所在的系统等",
        },
        item5: {
          title: "生物识别",
          descript: "使用用户的生物信息进行识别，如：指纹信息、人脸识别等",
        },
      },
      blockTwo: {
        title: "保护用户免受凭证盗窃和欺诈",
        descript1:
          "多因素认证 MFA 是防止账户被盗取有效的方法之一。攻击者如果想要入侵受 MFA 保护的帐户，不仅需要盗取凭证，还需要验证额外附加的因素。",
        descript2:
          "通常，我们看到在处理敏感数据的行业倾向于使用 MFA。这些垂直领域没有额外的身份层，所以对 MFA 的需求迫切。",
      },
      blockThree: {
        imgUrl: "//files.authing.co/authing-website/mfa-flexiable-img.png",
        title: "多重能力，赋能身份认证灵活性",
        descript:
          "Authing 可集中配置多种密码以外的认证因子，包括动态令牌、证书、人脸、指纹等生物特征。可集成多种常见第三方认证源。同时提供开发者 API，支持其他应用使用 IDaaS 的身份认证能力。",
      },
    },
    advantage: {
      title: "使用自适应多因素认证 MFA 的优势",
      item1: {
        title: "开发者友好",
        descript: "提供开箱即用的端 SDK，方便端上开发者快速实现 MFA",
        list1: "支持多端：Web、iOS、Android",
        list2:
          "内置多种多因素认证端组件，如 OTP、验证码、指纹解锁、面部识别、图形锁等",
        list3: "仅需调用一个方法，就可唤起 MFA 认证组件",
      },
      item2: {
        title: "定制数据上报",
        descript: "定制数据上报，参与流程发起决策，覆盖更加复杂精细化场景",
        list1: "支持在 Authing SDK 初始化时数据上报",
        list2: "支持定时数据上报",
        list3: "支持应用运行时主动数据上报",
      },
      item3: {
        title: "基于策略",
        descript: "触发条件基于自定义策略，策略系统简单、高效、完备、灵活",
        list1: "简单：可以使用默认安全策略或预设好的命中条件",
        list2: "高效：毫秒级判断策略命中，多因素认证即刻唤起",
        list3:
          "完备：策略基于函数表达式描述，开发者可以获取到用户信息、设备、网络、位置、行为等信息来书写策略命中逻辑",
        list4:
          "灵活：可同时基于多种方式进行命中判断，以在身份验证过程的每个步骤评估风险因素",
      },
      item4: {
        title: "配置简单",
        descript: "基于友好的用户界面，快速配置具体应用的多因素认证 MFA",
        list1: "一键开启/关闭多因素认证",
        list2:
          "一键启用默认安全策略，不必理解策略配置，也能使应用安全性得到很大提高",
        list3:
          "预设十几种重要且常用的策略命中条件，即选即生效，不是工程师也能使用",
      },
    },
  },
  // 产品-mfa
  mfa: {
    banner: {
      title: "多因素认证 MFA",
      subtitle:
        "自适应多因素认证 MFA 是一种简单有效的安全实践方法，它能够在用户名和密码之外再额外增加一层安全保护。例如银行的 U 盾、异地登录要求手机短信验证。",
    },
    type: {
      title: "不同种类的认证因素",
      "item-one": {
        title: "问题校验",
        "list-one": "问题验证",
        "list-two": "密码验证",
      },
      "item-two": {
        title: "物理校验",
        "list-one": "一次性密码",
        "list-two": "二维码扫描",
        "list-three": "APP 验证推送",
      },
      "item-three": {
        title: "生物校验",
        "list-one": "指纹验证",
        "list-two": "面部验证",
        "list-three": "虹膜验证",
      },
    },
    advance: {
      title: "Authing MFA 的优势",
      "descript-one":
        "Authing 独有的微信小程序“终端动态认证”功能。通过手机接收小程序发送的动态口令，实现“多因素认证”的目的，采用该方案，则可以将账户安全系数提升至 99.99%。",
      "descript-two":
        "智能识别用户每次登录的安全级别，并以此为基础设置不同的登录策略,对不同人员、角色、部门设置二次验证规则,根据应用的重要程度，对不同应用按需设置二次验证启动规则。",
    },
  },
  // 产品-单点登录
  sso: {
    banner: {
      "title-one": "单点登录",
      "title-two": "一次就好",
      subtitle:
        "单点登录（SSO）是整合企业系统的解决方案之一，旨在多个应用系统中，用户只需要登录一次就可以访问所有相互信任的应用系统。",
    },
    platform: {
      title: "Authing 单点登录平台",
      "descript-one":
        "Authing 凭借突破性的单点登录技术，无需任何开发，实现成员、客户在一处访问任何软件服务，并统一管控身份权限。",
      "descript-two":
        "如果你是一名开发者，Authing 还支持通过 OAuth2、OIDC、SAML、LDAP 等任何协议，配合统一用户池，最低五行代码轻松实现单点登录，实现登录定制化。",
    },
    scene: {
      title: "不同场景下的单点登录应用",
      "item-one": {
        title: "内部员工身份",
        "descript-one":
          "严控权限：身份管理解决方案提供了轻松的方法控制用户的不同访问级别。当员工加入公司或晋升时，可以轻松在一处分配和更改不同应用的权限。企业也可以在员工离职时，轻松取消、撤销所有不同平台的访问权限。",
        "descript-two":
          "高效办公：Authing 为企业提供一站式的团队应用平台，实现成员和合作伙伴在一处即可访问任何本地、云端的软件服务，并集中管控其访问权限，打造高效的办公方式，简化人事、IT管理，加速企业成长。",
        "descript-three":
          "轻松整合：既可以集成任何企业系统，也汇集了上千款已集成的应用程序，帮助各行各业找到了合适的技术，包括亚马逊、高等教育出版社、东南大学等优秀企业，让IT 管理不再复杂。",
      },
      "item-two": {
        title: "外部用户身份",
        "descript-one":
          "促进业务：在任何浏览器、任何设备中，Authing都可以为终端用户提供跨平台、无差别的单点登录体验。通过为客户提供统一的品牌访问体验，促进客户合作。",
        "descript-two":
          "分析机会：利用 Authing 整合来自不同身份源的多种用户数据。通过脱敏处理后，公司可以利用这些数据有效推动市场和销售机会。",
        "descript-three":
          "加速上线：Authing 提供直观的登录界面，以优化注册和登录，大幅缩短设计周期、节约营销资源，从而实现业务应用的快速上线。",
      },
      "item-tree": {
        title: "为你的客户开发",
        "descript-one":
          "实现你的客户的成功是我们的目标。随着企业数字化程度提高，每个政企都在使用或开发多种软件技术。无论任何平台、任何技术，通过 Authing 文档和 SDK，都可以实现快速集成单点登录的认证、授权。",
      },
    },
    advance: {
      title: "Authing 单点登录的优势",
      subtitle:
        "Authing 支持通过 OAuth2、OIDC、SAML、LDAP  等任何协议，配合统一用户池，最低五行代码轻松实现单点登录。",
      "item-one": {
        title: "高度安全",
        "list-one": "过程中无密码传递",
        "list-two": "Authing 和对接应用之间定期进行密钥的轮换",
        "list-three": "采用令牌失效机制，有效防范中间人攻击和回放攻击",
        "list-four": "精细化的用户身份属性的映射与转换管理",
      },
      "item-two": {
        title: "Authing SDK 支持无接口应用或自研系统",
        "list-one": "支持 SAML，OIDC，CAS，OAuth 等国际标准协议",
        "list-two": "根据不同人员（组）设定不同的密码策略",
        "list-three": "可以通过简单的配置，完成应用的上架和开启",
        "list-four": "支持自定义标准协议（custom protocol）：钉钉、腾讯等",
      },
      "item-three": {
        title: "预集成大量市场主流的 SaaS 和本地部署应用",
        "list-one": "Authing 为没有单点登录接口的厂商或者自研系统提供 SDK",
        "list-two": "支持多种语言 Java、Python、Node.js、PHP 等",
        "list-three": "最少仅需五行代码即可接入 Authing 单点登录",
      },
      "item-four": {
        title: "强大的访问策略引擎",
        "list-one": "对不同的部门、应用、人员等属性按需设置相应的访问权限",
        "list-two": "安全策略，提升安全性",
        "list-three": "集成二次认证服务，提高相应安全等级",
        "list-four": "支持任意数量的安全策略",
      },
    },
  },
  // 产品-单点登录新版
  ssoPage: {
    banner: {
      title: "单点登录 SSO",
      subtitle:
        "单点登录 SSO 是整合企业系统的解决方案之一，旨在多个应用系统中，用户只需要登录一次就可以访问所有相互信任的应用系统。",
      img: "//files.authing.co/authing-website/sso-banner-img-v3.png",
    },
    advantageData: {
      0: { label: "节省用户登录时间", value: "90%" },
      1: { label: "提升 IT 集成速率", value: "500%" },
      2: { label: "减少登录相关咨询", value: "75%" },
    },
    box_one: {
      img: "//files.authing.co/authing-website/sso-access-img-v4.png",
      alt: "支持多种协议的单点登录",
      title: "一次登录，轻松访问所有应用",
      content_one:
        "Authing 凭借单点登录 SSO 技术，实现成员、客户在一处访问任何软件服务，并统一管控身份权限。无论通过企业联合、 社会登录还是用户名和密码身份验证，用户只需登录一次，就可以使用他们被授予访问权限的所有应用。",
      content_two:
        "Authing 支持 OAuth2、OIDC、SAML、LDAP 等多种协议，开发者可以配合统一用户池，最低五行代码轻松实现单点登录，统一门户，并进行登录定制化。",
    },
    box_two: {
      title: "一手掌握，安全管理所有用户",
      content:
        "使用单点登录 SSO 构建和维护身份平台是昂贵、耗时的，而且难以正确实现。在最近一项调查中，94% 的组织表示，他们能够在不到一个月的时间内实施 Authing。通过 Authing 的单点登录解决方案，你可以得到：",
      left: {
        title: "合作网络",
        content:
          "Authing 拥有 2,000 多个预先构建的集成网络，可帮助你安全地采用和部署单点登录 SSO 到云应用，而无需自己构建和维护集成。",
        link: "探索 Authing 合作网络",
      },
      right_one: {
        title: "一个中央控制台",
        content:
          "Authing 为你提供一个中央控制台来查看、管理和保护所有用户的访问权限，无论他们是内部员工还是外部合作伙伴。",
        link: "探索控制台",
      },
      right_two: {
        title: "身份存储集成",
        content:
          "Authing 的单点登录解决方案可以快速连接到任意数量的身份存储并与之同步，包括 AD、LDAP、HR 系统和其他第三方身份提供商。",
        link: "查看文档",
      },
      right_three: {
        title: "自适应安全策略",
        content:
          "借助 Authing 单点登录服务，你可以对不同的部门、应用、人员等属性按需设置相应的访问权限。并自动识别和阻止恶意登录，提高相应安全等级。",
        link: "查看文档",
      },
    },
    box_three: {
      title: "不同场景下的单点登录应用",
      link: "免费使用",
      0: {
        label: "内部员工身份",
        subLabel: "不同场景下的单点登录应用",
        content:
          "你的员工需要访问各种服务和第三方应用。 Authing 为企业实现员工和合作伙伴在一处即可访问任何本地、云端的软件服务，并集中管控其访问权限，打造高效的办公方式，简化人事、IT管理，加速企业成长。",
        imgUrl: "//files.authing.co/authing-website/sso-inneruser-img-v3.png",
        alt: "单点登录统一门户",
      },
      1: {
        label: "外部用户身份",
        subLabel: "你的用户需要单点登录 SSO",
        content:
          "提供一流的身份验证体验对于在用户永无止境的竞争中脱颖而出至关重要。 「单点登录」可以将多个应用和服务联系在一起，以获得更有凝聚力的用户体验。",
        imgUrl: "//files.authing.co/authing-website/sso-outuser-img-v2.png",
      },
      2: {
        label: "为你的客户开发",
        subLabel: "通过多租户单点登录发展你的业务",
        content:
          "企业需要「单点登录」来集成应用并支持企业联合客户端，如 Active Directory、LDAP 或 Ping。 「单点登录」缩短了销售周期，是增长的催化剂，是企业客户的必备品。",
        imgUrl: "//files.authing.co/authing-website/sso-develop-img-v2.png",
      },
    },
  },
  // 产品-通用组件
  // comp: {
  //   banner: {
  //     title: "通用登录组件",
  //     subtitle:
  //       "登录组件（Guard）帮助开发者屏蔽了很多底层认证的实现细节，同时也包括繁琐的 UI 开发。",
  //   },
  //   comp: {
  //     title: "什么是登录组件？",
  //     descript:
  //       "登录组件（Guard）是一种可嵌入的登录表单，可根据你的需求进行配置，建议用于单页面应用程序。 它使你可以轻松添加各种社会化登录方式，以便你的用户可以无缝登录，并且在不同平台拥有一致的登录体验。",
  //   },
  //   effect: {
  //     title: "登录组件接入效果",
  //   },
  //   compare: {
  //     title: "登录组件 VS 自定义 UI",
  //     "item-one": {
  //       title: "Authing 通用登录表单 Guard",
  //       "list-one":
  //         "拥有精美的设计，适合大多数现代网站，只需对其选项进行一些调整。",
  //       "list-two": "支持跨平台，所有平台均能接入",
  //       "list-three": "初始化时有详细的参数，可以控制整个表单的行为",
  //       "list-four":
  //         "支持手机-密码、邮箱-密码、忘记密码、重置密码等繁琐且需要重复开发的功能",
  //       "list-five": "由 Authing 保证安全的认证",
  //     },
  //     "item-two": {
  //       title: "自定义 UI",
  //       "list-one": "贵司对 UI 有严格的设计要求和统一性要求",
  //       "list-two": "贵司希望能在现有 UI 上做改动",
  //       "list-three": "允许前端开发专家使用 HTML，CSS 和 JavaScript 进行自定义",
  //       "list-four": "由 Authing 保证安全的认证",
  //     },
  //   },
  // },
  // 产品-通用组件
  guard: {
    banner: {
      title: "通用登录组件",
      subtitle:
        "通用登录组件（Guard）是一种可嵌入的登录表单，可以根据需求进行自定义配置，轻松添加各种社会化登录方式，以便用户可以无缝登录，在不同平台拥有一致的登录体验。",
    },
    advantageData: {
      0: {
        label: "每年身份认证次数",
        value: `100 M+</span>`,
      },
      1: {
        label: "即需即用的 SDK",
        value: `1000+`,
      },
      2: { label: "可用性和稳定性", value: "99.99%" },
    },
    freamwork: {
      // title: "用户的安全登录基础架构",
      title: "免去繁琐开发，帮助企业快速上线",
      // subtitle: "免去繁琐开发，帮助企业快速上线",
      descript:
        "通用登录组件（Guard）帮助开发者屏蔽了很多底层认证的实现细节，同时也包括繁琐的 UI 开发。使得企业和开发者可以快速上线安全的、跨平台的统一登录表单。",
    },
    features: {
      title: "多重能力，赋能用户登录体验",
      item1: {
        title: "拥有丰富的登录注册方式",
        subtitle:
          "账号密码/手机验证码/APP 扫码/小程序扫码/企业身份源/社会化登录。",
      },
      item2: {
        title: "内置多种功能，无需额外编写代码",
        subtitle:
          "内置了忘记密码的交互 UI、多因素认证（MFA）功能，用户无需编写任何额外代码，即可使用该组件完成任务。",
      },
      item3: {
        title: "拥有响应式布局",
        subtitle:
          "不仅完美兼容移动端和 PC 端，还可以用 CSS 轻松自定义登录框样式。",
      },
      item4: {
        title: "兼容前端所有主流框架",
        subtitle: "包括 React、Vue、Angular、JavaScript 等登录组件。",
      },
    },
    flexibility: {
      title: "轻松嵌入任何应用，登录由你灵活定义",
      subtitle:
        "如果你希望将登录框直接嵌入你的网站而不是重定向到通用登录页面， Guard 将是实现嵌入式登录的首选方法。",
      descript:
        "Guard 可以轻松嵌入到你的应用程序中，进行自定义以启用多个社交提供商，并根据你的品牌进行设计。</br></br>如果你对 UI 有严格的设计要求和统一性要求，希望能在现有 UI 上做改动。Guard 允许前端开发专家使用 HTML，CSS 和 JavaScript 进行自定义。",
    },
  },
  verifyPage: {
    banner: {
      title: "手机号码闪验",
      subtitle:
        "依托于微信官网的实名用户信息，用户一键授权即可以真实号码完成注册/登录，为开发者建立以手机号码为基础的账号体系。",
    },
    advantageData: {
      0: { label: "简化登录流程", value: "51%" },
      1: { label: "手机不插卡也可认证", value: "100%" },
      2: { label: "减少运维难度", value: "81%" },
    },
    intro: {
      title: "PC 网站使用小程序扫码登录",
      descript:
        "在 Authing 中开启扫描小登录二维码登录后可以获得微信官方的实名用户信息，用户一键授权即可以真实号码完成注册或者登录，为开发者建立以手机号码为基础的账号体系。",
      descript1: "你可以",
      weixinLogin: " 点击此处体验小程序扫码登录",
    },
    "step-one": {
      title: "第一步：在微信公众平台创建小程序（可选）",
      descript1:
        "默认情况下，小程序扫码登录会使用 Authing 提供的默认小程序，如果你需要有更强的品牌定制能力，或者想让通过小程序扫码登录的用户微信账号和自己的其他微信公众平台打通，你需要申请自己的小程序。如果你属于这两种场景的一种：",
      descript2: "请前往 ",
      descript3:
        " 指引创建一个微信小程序，你需要记录下该应用的 App ID 和 App Secret，后面需要用到。",
      descript4: " 同时你需要联系我们获取小登录的源码，",
      weixinPlatform: "微信公众平台",
      consult: "点击详情咨询",
    },
    "step-two": {
      title: "第二步：在 Authing 控制台配置微信小程序扫码应用",
      descript:
        "在控制台的社会化登录配置页面，找到微信小程序扫码登录，填入以下配置：",
      list1: "Logo: 上传后的 Logo，将作为小程序二维码中央的 Logo；",
      list2:
        "登录后回调链接: 此链接一般填你的业务地址，如果配置了这个链接，用户在完成登录之后，浏览器将会携带用户信息跳转到该页面；",
      list3: "AppID: 小程序的 AppID，选择私有化小程序的用户填；",
      list4: "AppSecret: 小程序的 AppSecret，选择私有化小程序的用户填。",
    },
    "step-three": {
      title: "第三步：开始开发接入",
      descript:
        "小程序扫码登录支持三种接入方式：使用 JavaScript SDK、使用嵌入登录组件、 使用托管登录页，每种不同的接入方式各有优劣点，你可以根据自己的业务需求来选择合适的方式。",
      item1: {
        title: "JavaScript SDK",
        list1: "接入简单，只需要几行代码",
        list2: "可自定义程度最高",
      },
      item2: {
        title: "嵌入登录组件",
        list1: "接入简单，只需要几行代码",
        list2: "可以将该组件集成到你的应用",
        list3: "自定义程度相对较高",
      },
      item3: {
        title: "托管登录页",
        list1: "运维简单，由 Authing 负责运维",
        list2: "每个应用有一个独立的二级域名",
      },
    },
  },
  // 产品-手机验证
  verify: {
    banner: {
      title: "用户手机不插卡也能认证他号码",
      subtitle:
        "依托于微信官方的实名用户信息， 用户一键授权即可以真实号码完成注册/登录， 为开发者建立以手机号码为基础的账号体系。",
      userInfo: "登录成功，以下是你的个人信息",
    },
    scan: {
      wx: "使用微信扫码",
      modal: {
        "modal-tip": "登录成功，以下是你的个人信息",
        doc: "文档",
        "ordinary-mode": "切换标准模式",
        "json-mode": "切换 JSON 模式",
        welcom: "欢迎你，获取到授权的手机号为",
        "base-info": "基本信息",
        username: "用户名",
        phone: "授权手机号",
        time: "授权时间",
        "user-id": "用户 ID",
        "userpool-id": "用户池 ID",
        "open-id": "Open ID",
        "address-info": "地址信息",
        city: "城市名称",
        country: "国家名称",
        region: "所在地",
        "client-ip": "客户端 IP",
      },
    },
    product: {
      title: "产品展示",
    },
    example: {
      title: "客户案例",
      "item-one": {
        title: "句子互动",
        descript:
          "“ 作为一家聊天机器人公司，Authing 小登录小程序使我们一年的短信费率降低了至少 51%，它简化了登录流程，很好地解决了短信问题。”",
      },
      "item-two": {
        title: "高等教育出版社",
        descript:
          "“ 把登录与身份认证交给 Authing 后，我们的工程师能够更加专注于产品本身。Authing 的用户管理后台简明专业，收费相对其他服务商也更便宜。”",
      },
      "item-three": {
        title: "文因互联",
        descript:
          "“ Authing 使我们在部署应用时无需考虑用户系统，快速保证了我们对外业务的安全性，同时还能控制访问的用户，便于分析用户画像。”",
      },
    },
    price: {
      title: "产品价格",
      "item-one": {
        title: "号码认证次数 3000 次套餐包",
        detail: "0.05 元/次，总价 150 元",
      },
      "item-two": {
        title: "号码认证 7200 次套餐包",
        detail: "0.035 元/次，总价 2520 元",
      },
      "item-three": {
        title: "号码认证 450000 次套餐包包",
        detail: "0.03 元/次，总价 13500 元",
      },
    },
  },
  database: {
    banner: {
      title: "自定义数据库连接",
      subtitle:
        "当你想保障数据安全性或平滑迁移用户时，请使用 Authing 自定义数据库连接，既能连接自己维护的外部或本地数据库，也能将老旧系统的已有用户数据迁移至 Authing。",
    },
    intro: {
      description:
        "自定义数据库连接可将 Authing 与数据库进行解耦，在传统软件系统当中，应用系统和数据源要保持在同一个网络环境下，如果需要连接外部数据源，需要做大量的对接开发工作。Authing 的自定义数据库连接，可根据用户的需求进行高度可配置化，不仅支持 MySQL、MongoDB、PostgreSQL 等标准数据库解决方案，还支持 API 方式的数据源对接，通过虚拟沙箱环境运行用户自定义脚本，极大提高了数据的安全性。",
    },
    sence: {
      title: "使用场景",
      subtitle:
        "当你出于以下目的要提供对自己的独立身份数据库的访问时，请使用自定义数据库连接",
      item1: {
        title: "完全掌控用户数据",
        subtitle: "你不希望第三方服务商保存你的用户数据。",
      },
      item2: {
        title: "身份验证",
        subtitle:
          "将你的数据库用作 Authing 的身份提供者，以对用户进行身份验证。",
      },
      item3: {
        title: "迁移用户",
        subtitle: "对用户无感知的惰性迁移用户数据到 Authing。",
      },
    },
    advantage: {
      title: "产品优势",
      list1: "使用自定义数据库连接，能最大化地节省时间，提高工作效率。",
      list2: "可适配于多种场景中，灵活度高。",
      list3: "完全掌握用户数据，没有用户数据泄漏风险。",
      list4:
        "目前国产身份云厂商中仅 Authing 支持自定义数据库连接，无需额外定制，降低老旧应用系统接入成本。",
    },
    solution: {
      title: "典型的数据库连接方案",
      item1: {
        title: "使用 Authing 提供的数据库",
        list1:
          "Authing 提供了数据库基础结构来默认存储你的用户。 由于所有数据都存储在 Authing 中，因此该方案为身份验证过程提供了高效性能。",
        list2:
          "Authing 托管的数据库是高度安全的。 密码不会以纯文本形式存储或登录，而是使用 bcrypt 进行哈希处理，此外，还可以实施各种级别的密码安全要求。",
      },
      item2: {
        title: "使用自定义数据库连接",
        list1:
          "如果你有现有的用户存储，或者希望将用户凭据存储在自己的服务器上，Authing 可以连接到你配置的自定义数据库连接，并将其作为身份源。",
        list2:
          "在这种情况下，你提供登录脚本来对尝试登录时执行的用户进行身份验证。 本质上，你可以使用自定义脚本连接到任何种类的数据库或 Web 服务。",
      },
      item3: {
        title: "从自定义数据库迁移到 Authing",
        list1:
          "如果你的用户数据存储在原有系统的数据库中，希望将用户迁移到 Authing。这时候，Authing 提供了一种自动迁移功能，可以在每次登录时，自动将你的用户添加到 Authing 的数据库中，并且避免要求你的用户重置密码。",
      },
    },
    table: {
      title: "自定义数据库连接能力厂商对比",
      subtitle:
        "目前支持自定义数据库连接功能的厂商，全球仅有 2 家，分别是国外的 Auth0 和国内的 Authing。",
      manufacturer: "厂商",
      supported: "是否支持",
      item1: {
        title: "Authing",
        supported: "支持",
      },
      item2: {
        title: "Auth0",
        supported: "支持",
      },
      item3: {
        title: "Okta",
        supported: "不支持",
      },
      item4: {
        title: "阿里云 IDaaS",
        supported: "不支持，需要定制开发",
      },
      item5: {
        title: "玉符",
        supported: "不支持",
      },
      item6: {
        title: "竹云",
        supported: "不支持",
      },
    },
  },
  databasePage: {
    banner: {
      title: "自定义数据库连接",
      subtitle:
        "当你想保障数据安全性或平滑迁移用户时，请使用 Authing 自定义数据库连接，既能连接自己维护的外部或本地数据库，也能将老旧系统的已有用户数据迁移至 Authing。",
    },
    advantageData: {
      0: { label: "提高工作效率", value: "79%" },
      1: { label: "防止用户数据泄露", value: "100%" },
      2: { label: "降低应用系统接入成本", value: "90%" },
    },
    solutions: {
      title: "高度配置化的数据库解决方案",
      descript:
        "自定义数据库连接可将 Authing 与数据库进行解耦，并根据用户的需求进行高度可配置化，不仅支持 MySQL、MongoDB、PostgreSQL 等标准数据库解决方案，还支持 API 方式的数据源对接，通过虚拟沙箱环境运行用户自定义脚本，极大提高了数据的安全性。",
    },
    sence: {
      title: "自定义数据库连接的使用场景",
      descript:
        "当你出于以下目的要提供对自己的独立身份数据库的访问时，请使用自定义数据库连接：",
      list1: "完全掌控用户数据：你不希望第三方服务商保存你的用户数据。",
      list2:
        "身份验证：将你的数据库用作 Authing 的身份提供者，以对用户进行身份验证。",
      list3: "迁移用户：对用户无感知的惰性迁移用户数据到 Authing。",
    },
    "solution-docs": {
      title: "自定义数据库连接方案",
      item1: {
        title: "使用 Authing 提供的数据库",
        descript:
          "Authing 提供了高度安全的数据库基础结构来默认存储你的用户。 此外，还可以实施各种级别的密码安全要求，且密码不会以纯文本形式存储或登录，而是使用 bcrypt 进行哈希处理。",
      },
      item2: {
        title: "使用自定义数据库连接",
        descript:
          "如果你希望将用户凭据存储在自己的服务器上，Authing 可以连接到你配置的自定义数据库连接，并将其作为身份源。本质上，你可以使用自定义脚本连接到任何种类的数据库或 Web 服务。",
      },
      item3: {
        title: "从自定义数据库迁移到 Authing",
        descript:
          "如果你的用户数据存储在原有系统的数据库中，希望将用户迁移到 Authing。这时，Authing 提供了一种自动迁移功能，可以在每次登录时，自动将你的用户添加到 Authing 的数据库中，并且避免要求你的用户重置密码。",
      },
    },
    table: {
      title: "自定义数据库连接能力厂商对比",
      subtitle:
        "目前支持自定义数据库连接功能的厂商，全球仅有 2 家，分别是国外的 Auth0 和国内的 Authing。",
      manufacturer: "厂商",
      supported: "是否支持",
      item1: {
        title: "Authing",
        supported: "支持",
      },
      item2: {
        title: "Auth0",
        supported: "支持",
      },
      item3: {
        title: "Okta",
        supported: "不支持",
      },
      item4: {
        title: "阿里云 IDaaS",
        supported: "不支持，需要定制开发",
      },
      item5: {
        title: "玉符",
        supported: "不支持",
      },
      item6: {
        title: "竹云",
        supported: "不支持",
      },
    },
  },
  authority: {
    banner: {
      title: "权限管理",
      subtitle:
        "权限管理功能，是我们为了满足大型系统中复杂组织架构的设计需求，将资源、角色、权限授权统一组合到一个权限分组中，方便开发者进行管理。",
    },
    advantageData: {
      0: { label: "增加组织效率", value: "75%" },
      1: { label: "减少管理难度", value: "40%" },
      2: { label: "用户正在受益", value: "3000W+" },
    },
    features: {
      item1: {
        title: "什么是基于角色的访问控制（RBAC）",
        descript:
          "基于角色的访问控制（Role-based access control，简称 RBAC），指的是通过用户的角色（Role）授权其相关权限，这实现了更灵活的访问控制，相比直接授予用户权限，要更加简单、高效、可扩展。",
        sub: {
          title: "RBAC 应用场景",
          descript:
            "以一个简单的场景（Gitlab 的权限系统）为例，用户系统中有 Admin、Maintainer、Operator 三种角色，这三种角色分别具备不同的权限，比如只有 Admin 具备创建代码仓库、删除代码仓库的权限，其他的角色都不具备。",
        },
      },
      item2: {
        title: "什么是基于属性的访问控制（ABAC）",
        descript:
          "基于属性的访问控制（Attribute-Based Access Control，简称 ABAC）是一种非常灵活的授权模型，不同于 RBAC，ABAC 则是通过各种属性来动态判断一个操作是否可以被允许。",
        sub: {
          title: "ABAC 应用场景",
          list1: "在 ABAC 权限模型下，你可以轻松地实现以下权限控制逻辑：",
          list2: "文档的所属部门跟用户部门相同时，用户可以访问这个文档；",
          list3: "早上九点前禁止 A 部门的人访问 B 系统；",
          list4: " 在除了上海以外的地方禁止以管理员身份访问 A 系统；",
          descript:
            "如果浓缩到一句话，你可以细粒度地授权在何种情况下对某个资源具备某个特定的权限。",
        },
      },
      item3: {
        title: "Authing 的权限模型",
        descript1:
          "在 Authing 的权限系统中，我们通过用户、角色这两种对象实现了 RBAC 模型的角色权限继承，在此之上，我们还能围绕属性进行动态地、细粒度地授权，从而实现了 ABAC 权限模型。",
        descript2:
          "同时，我们为了满足大型系统中复杂组织架构的设计需求，将资源、角色、权限授权统一组合到一个权限分组中，方便开发者进行管理。",
      },
    },
    model: {
      title: "你该如何选择使用哪种权限模型",
      item1: {
        title: "如果满足以下条件，请选择 ABAC",
        list1: "你在一个拥有许多用户的大型组织中",
        list2: "你需要深入的特定访问控制功能",
        list3: "你有时间投资远距离的模型，需要确保隐私和安全合规",
      },
      item2: {
        title: "如果满足以下条件，请选择 RBAC",
        list1: "你所在的是中小型企业",
        list2: "你的访问控制策略广泛",
        list3: "你的外部用户很少，并且你的组织角色得到了明确定义",
      },
    },
  },
  common: {
    "check-doc": "查看文档",
    "contact-us": "联系我们",
  },
};
